import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function OrderTerminationModal() {
    const [show, setShow] = useState(true);

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            aria-labelledby="order-termination-modal-title"
            centered
            scrollable
            size="lg"
        >
            <Modal.Header closeButton closeLabel="Zavřít">
                <Modal.Title id="order-termination-modal-title">
                    UKONČENÍ OBJEDNÁVEK
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="order-termination-modal-body">
                <p>
                    Milí zákazníci a přátelé, ráda bych Vám z celého srdce poděkovala za Vaši
                    přízeň a každou jednu objednávku zákusků, dortu nebo koláčů. Právě díky Vaší
                    podpoře se mi plní velký sen…
                </p>
                <p>
                    <strong>S pečením na zakázku k dnešnímu dni trvale končím.</strong> Důvod je
                    ale skvělý – od 1. září přebíráme <strong>VLASTNÍ KAVÁRNU.</strong>
                </p>
                <p>
                    Mé zákusky už sice nepůjde objednat domů, ale budete si na nich moci pochutnat
                    v příjemném prostředí u skvělé kávy nebo je koupit přímo v kavárně. Budu ráda,
                    když nás navštívíte.
                </p>
                <div className="order-termination-modal-details">
                    <p><strong>KDE:</strong> Kavárna DUO coffee na náměstí v Havířově</p>
                    <p><strong>OTEVÍRÁME:</strong> 1. 9. 2026</p>
                </div>
                <p>
                    Facebookové stránky, Instagram a webové stránky právě připravujeme. Až budou
                    hotové, přidám sem kontakt.
                </p>
                <p className="mb-0">
                    Těším se na Vás a děkuji za pochopení a stálou přízeň.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => setShow(false)}>
                    Rozumím
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OrderTerminationModal;
